import { RouteEnums } from '@Helper/Enums';
import { Avatar } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { RootAssets } from '../../../config/rootAssets';
import {
  ComponentHelper,
  useEffectAsync,
  UserHelper,
} from '../../../helper/Infra';
import { MergefloColors } from '../../../helper/MergefloColors';
import { postAssets } from '../../../store/feature/assetsSlice';
import {
  getPlayBookDetail,
  postPlayBookId,
  postSectionList,
} from '../../../store/feature/playBookDetailSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import classes from './UserMenu.module.css';

interface UserProps {
  playbookId?: string;
  username: string;
  setUsername: (username: string) => any;
  handleSelect: (username: string | null) => any;
  disabled?: boolean;
}

export default function UserMenu(props: UserProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const { pid } = useParams();
  let userHelper = new UserHelper();
  const componentHelper = new ComponentHelper();
  const [selectedUserName, setselectedUserName] = useState<string>(
    props.username
  );
  const [selectedUserIcon, setselectedUserIcon] = useState<string>('');
  const handleClose = () => {
    setAnchorEl(null);
  };
  let navigate = useNavigate();
  const { userList } = useAppSelector(getPlayBookDetail);
  const dispatch = useAppDispatch();
  const mergefloColors = new MergefloColors();
  const selectedUser = userList.find(i => i.username === props.username);

  const [selectedIndex, setSelectedIndex] = React.useState(
    selectedUser ? userList.indexOf(selectedUser) : 0
  );

  useEffectAsync(async () => {
    if (!userList.length && pid) {
      dispatch(postPlayBookId(pid));
      const data = await componentHelper.loadData(pid);
      dispatch(postSectionList(data.section));
      const assets = await userHelper.getAssets();
      if (assets === null) {
        navigate(RouteEnums.Login);
        return;
      }
      dispatch(postAssets(assets as RootAssets));
    }
  }, [userList]);

  React.useEffect(() => {
    if (props.username) {
      const selectedUser = userList.find(i => i.username === props.username);

      let userFullName = '';
      let userIcon = '';

      if (selectedUser) {
        if (selectedUser.name.length > 0) {
          userFullName = selectedUser.name;
          userIcon = selectedUser.name.charAt(0).toUpperCase();
        }

        if (selectedUser.surname.length > 0) {
          userFullName += ' ' + selectedUser.surname;
          userIcon += selectedUser.surname.charAt(0).toUpperCase();
        }
        if (userFullName.length === 0) {
          userFullName += ' ' + selectedUser.username.trim();
          userIcon += selectedUser.username.trim().charAt(0).toUpperCase();
        }

        setSelectedIndex(userList.indexOf(selectedUser));
      } else {
        userFullName = '';
        userIcon = '';
      }

      setselectedUserName(userFullName);
      setselectedUserIcon(userIcon);
    } else {
      setselectedUserName('');
      setselectedUserIcon('');
    }
  }, [props, userList]);

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className={classes.UserMenu}
        disabled={props.disabled}
      >
        <div className={classes.UserMenuAvatar}>
          {selectedUserName === '' ||
          selectedUserName === null ||
          selectedUserName === undefined ? (
            <>
              <Avatar
                style={{
                  fontSize: 14,
                  width: 28,
                  height: 28,
                  backgroundColor: 'transparent',
                  color: '#7D7A9A',
                }}
              ></Avatar>

              <span style={{ marginLeft: 8 }}>Unassigned</span>
            </>
          ) : (
            <>
              <Avatar
                sx={{
                  bgcolor: mergefloColors.getUserColors(selectedUserName),
                  width: 28,
                  height: 28,
                  fontSize: 16,
                }}
              >
                {selectedUserIcon}
              </Avatar>

              {selectedUserName}
            </>
          )}
        </div>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          selected={
            selectedUserName === '' ||
            selectedUserName === null ||
            selectedUserName === undefined
          }
          onClick={a => {
            setselectedUserName('');
            setselectedUserIcon('');
            props.setUsername('');
            props.handleSelect(null);
            setAnchorEl(null);
          }}
        >
          <Avatar
            style={{
              fontSize: 14,
              width: 28,
              height: 28,
              backgroundColor: '#635ea4',
            }}
          ></Avatar>
          <span style={{ marginLeft: 8 }}>Unassigned</span>
        </MenuItem>
        {userList &&
          userList !== null &&
          userList
            .filter(u => u.playbookId === props.playbookId)
            .map((i: any, index) => {
              return (
                <MenuItem
                  key={i.username}
                  selected={index === selectedIndex}
                  onClick={a => {
                    setselectedUserName(i.username);
                    props.setUsername(i.username);
                    props.handleSelect(i.username);
                    setAnchorEl(null);
                  }}
                >
                  <Avatar
                    style={{
                      fontSize: 14,
                      width: 28,
                      height: 28,
                      backgroundColor: '#635ea4',
                    }}
                  >
                    {i && i.name && i?.name.length ? i.name[0] : i.username[0]}
                  </Avatar>
                  <span style={{ marginLeft: 8 }}>
                    {i.name ? `${i.name} ${i.surname}` : i.username}
                  </span>
                </MenuItem>
              );
            })}
      </Menu>
    </div>
  );
}
